"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
function BenefitMulti(props) {
    var style = props.style, className = props.className, list = props.list, icon = props.icon, _a = props.layout, layout = _a === void 0 ? 'left' : _a;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var layoutCls = "layout-".concat(layout);
    function renderItem(key, data) {
        var title = data.title, describe = data.describe;
        return (react_1.default.createElement("div", { key: key, className: "multi-item" },
            react_1.default.createElement("div", { className: "title" }, title),
            react_1.default.createElement("div", { className: "desc" }, describe)));
    }
    return (react_1.default.createElement("div", { style: style, className: (0, classnames_1.default)("".concat(classPrefix, "-benefit-multi"), layoutCls, className) },
        react_1.default.createElement("div", { className: "multi-list" }, list.map(function (l, i) { return renderItem("multi-item-".concat(i), l); })),
        react_1.default.createElement("div", { className: "multi-icon", style: { backgroundImage: "url(".concat(icon, ")") } })));
}
exports.default = BenefitMulti;
//# sourceMappingURL=BenefitMulti.js.map